import { render, staticRenderFns } from "./deleteFolder.vue?vue&type=template&id=06041261&scoped=true&"
import script from "./deleteFolder.vue?vue&type=script&lang=js&"
export * from "./deleteFolder.vue?vue&type=script&lang=js&"
import style0 from "./deleteFolder.vue?vue&type=style&index=0&id=06041261&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06041261",
  null
  
)

export default component.exports